
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'
import attention from '@/assets/icons/attention.svg'
import AsahiTypography from '@/components/library/Typography.vue'

export default defineComponent({
  components: { AsahiTypography },
  props: {

  },
  computed: {
    ...mapState('basket', ['id', 'query', 'items', 'paymentMethod']),
    ...mapGetters('basket', ['progressBarSuccess', 'showProgressBarMessage']),
    ...mapState('catalog', ['alignment']),

    progressBar () {
      return this.query.progress_bar_data
    },
    isDeliveryCondition () {
      return this.query.delivery_method === 'flatrate_flatrate' || this.query.delivery_method === 'selfpickup_selfpickup'
    },
    isMinimumOrderWeightReached () {
      return this.progressBar?.iTotalCartWeight > 0 && this.progressBar?.iTotalCartWeight >= this.progressBar?.iMinimumOrderWeight
    },
    isMinimumPalletQualtityReached () {
      return this.progressBar?.iTotalCartPalletQty >= this.progressBar?.iMinimumOrderPallet
    },
    isCartItemNonPLNCondition () {
      const nonPLNProduct = this.items?.filter((item : any) => item?.is_free_beer === 0)
      const itemCondition = nonPLNProduct ? nonPLNProduct.filter((item : any) => (item?.number_of_layer > 0 && item?.number_of_packages >= 0)) : []
      return (nonPLNProduct && itemCondition && nonPLNProduct.length > 0 && itemCondition.length > 0)
    },
    displayDiscountMessage () {
      return (this.isDeliveryCondition &&
        this.isMinimumOrderWeightReached &&
        this.isMinimumPalletQualtityReached &&
        this.isCartItemNonPLNCondition)
    }

  },
  data () {
    return {
      attention
    }
  },
  methods: {

  }
})
